<template>
  <div class="">
    <el-card
      class="settings"
      shadow="never">
      <div
        slot="header"
        class="settings-header">服务产品组件<el-button
          type="danger"
          style="margin-left: 8px;"
          @click="deleteitem">删除</el-button></div>
      <el-form
        ref="series"
        :model="series"
        label-width="100px">
        <el-form-item
          label=""
          label-width="0">
          <el-button
            type="primary"
            style="margin-bottom: 10px;"
            @click="addGoods">选择服务</el-button>
          <el-table
            border
            :data="series.graphics">
            <el-table-column
              label="服务名称"
              min-width="180"
              prop="serviceCategoryName"> </el-table-column>
            <el-table-column
              label="操作"
              width="80"
              prop="vendorAddress">
              <template slot-scope="{ row, $index }">
                <el-button
                  type="text"
                  @click="deleteRow($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

      <we-series-select-modal
        ref="vendor"
        @select="handleSelect" />
    </el-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import WeSeriesSelectModal from './we-series-select-modal.vue'
export default {
  name: 'WeVendor',
  components: { WeSeriesSelectModal },
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'servicecategoryshow', graphics: [], layoutType: 2, visible: false }
      }
    },
    index: Number
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    series: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    deleteRow($index) {
      this.series.graphics.splice($index, 1)
    },
    addGoods() {
      const selection = this.series.graphics.map(i => i.vendorId)
      this.$refs.vendor.fetch(selection)
    },
    handleSelect(row) {
      console.log(this.series)
      this.$message.success('添加成功')
      this.series.graphics.push(row)
    },
    submit() {
      return new Promise((resolve, reject) => {
        const graphics = this.series.graphics
        if (graphics.length === 0) {
          this.$message.error('请选择服务')
          reject(new Error(JSON.stringify({ index: this.index })))
        } else {
          resolve()
        }
      })
    }
  }
}
</script>
